import styled from 'styled-components';

const WordWrapParagraph = styled.p`
    box-shadow: none;
    border-radius: 0;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    min-height: 3.125rem;
    width: 100%;
    border: 0.063rem solid ${props => props.theme.color};
    font-size: 1rem;
    box-sizing: border-box;
    padding: 0.75rem 1.25rem;
    margin:0;

    ${props => props.disabled ? `
        background: none;
        border: 0.063rem solid #AAAAAA;
        color: #666666;
        -webkit-text-fill-color: #666666;
        opacity: 1; /* required on iOS */
    `: ''}
    
    &:focus {
        outline: none;
    }
`;

export default WordWrapParagraph;